import { useContext } from 'react'
import { AuthContextProps } from '../models/Context'
import { AuthContext } from 'Auth/context/context'

export const useAuth = (): AuthContextProps => {
  const context = useContext<AuthContextProps | undefined>(AuthContext)

  if (!context) {
    throw new Error(
      'AuthProvider context is undefined, please verify you are calling useAuth() as child of a <AuthProvider> component.'
    )
  }

  return context
}
